"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translationReportController = void 0;
const endpoints_1 = require("../../../constants/endpoints");
const typescriptHacks_1 = require("../../../helper/typescriptHacks");
const apiPath = endpoints_1.endpoints.translationReport;
const translationReportController = (service) => ({
    create: (item) => {
        return service.post(apiPath, item, service.addAccessTokenToHeaders);
    },
    readAll: () => {
        return service.get(apiPath, service.addAccessTokenToHeaders);
    },
    resolve: (guid) => {
        return service.put(`${apiPath}/${guid}`, typescriptHacks_1.anyObject, service.addAccessTokenToHeaders);
    },
    close: (guid) => {
        const url = `${apiPath}/${guid}`;
        return service.delete(url, service.addAccessTokenToHeaders);
    }
});
exports.translationReportController = translationReportController;
